import { SearchResultModel } from "./searchResultModel"

export class PageSearchResultModel extends SearchResultModel {
  getName(locale) {
    if (!this.document || !this.document.title || !this.document.title[locale]) {
      return ""
    }
    return this.document.title ? this.document.title[locale] : ""
  }

  getText(locale) {
    if (!this.document || !this.document.pageTextBlocks || !this.document.pageTextBlocks[0] ||!this.document.pageTextBlocks[0][locale]) {
      return ""
    }
    return this.document.pageTextBlocks[0][locale]
  }

  getLinkUrl() {
    return this.document.url || "#"
  }
}
